/**
 * L2-R5: moved to @miq/shared-models (table/ag-table-grid-options.types.ts). This shim keeps the old
 * import path working; new code should import from '@miq/shared-models'.
 */
/*
 * The 5 `const enum`s here became plain enums in the lib (ng-packagr erases const enums).
 * `MiqAgCellRendererName` / `MiqAgCellEditorName` replace the `keyof typeof` references to
 * the component maps in ./ag-table-grid-options, which a library cannot import.
 */
export type { MiqAgCellRendererName, MiqAgCellEditorName, AgGridOptions, AgStreamParams, AgFilterParams, AgSortParams, AgStreamResult, CellRenderParams, DisplayFnSettings, MiqAgColumn } from '@miq/shared-models';
export { AgFilterType, AgGridFixedColumns, AgGridOptionsEditType, AgGridOptionsDomLayout, AgRowModelType, AgGridPinnedType, AgGridFilterOptons, RelationshipType, DisplayFormat, setTranslationsForAGGrid } from '@miq/shared-models';
